import request from '@/config/axios'

export interface ShareholderNoticeItemVO {
  notifyEnabled?: boolean
  wxaEnabled?: boolean
  wxaTemplateTitle?: string
  page?: string
}

export interface ShareholderNoticeConfigVO {
  become?: ShareholderNoticeItemVO
  upgrade?: ShareholderNoticeItemVO
  settle?: ShareholderNoticeItemVO
}

export interface ShareholderConfigVO {
  id?: number
  open?: boolean
  selfBuy?: boolean
  becomeType?: number
  becomeCheck?: boolean
  becomeOrder?: number
  becomeOrderCount?: number
  becomeMoney?: number
  becomeGoodsIds?: string
  noregDesc?: string
  bonusRate?: number
  settleDays?: number
  payCharge?: number
  payBegin?: number
  payEnd?: number
  levelType?: number
  levelUrl?: string
  openMemberCenter?: boolean
  closeCommissionCenter?: boolean
  settleCycle?: number
  openProtocol?: boolean
  protocolContent?: string
  textsJson?: string
  centerDesc?: string
  noticeJson?: string
}

export const getShareholderConfig = async () => {
  return await request.get<ShareholderConfigVO>({ url: '/trade/shareholder/config/get' })
}

export const saveShareholderConfig = async (data: ShareholderConfigVO) => {
  return await request.put({ url: '/trade/shareholder/config/save', data })
}

export const getShareholderNotice = async () => {
  return await request.get<ShareholderNoticeConfigVO>({ url: '/trade/shareholder/config/notice' })
}

export const saveShareholderNotice = async (data: ShareholderNoticeConfigVO) => {
  return await request.put({ url: '/trade/shareholder/config/notice', data })
}
